/* eslint-disable */
export const subscriptions = [
    {
        id: '0001',
        name: 'Prestine',
        customerEmail: 'info@prestine.in',
        activationDate: '2022-10-05T12:00:00.000Z',
        renewalDate: '2023-10-05T12:00:00.000Z',
        expiredDate: '2025-10-05T12:00:00.000Z',
        packageName: 'Basic',
        price: 5000,
        status: 'Active',
    },
    {
        id: '0002',
        name: 'Rajesh',
        customerEmail: 'rajesh@prestine.in',
        activationDate: '2022-10-05T12:00:00.000Z',
        renewalDate: '2023-10-05T12:00:00.000Z',
        expiredDate: '2025-10-05T12:00:00.000Z',
        packageName: 'Basic',
        price: 5000,
        status: 'Active',
    },
    {
        id: '0003',
        name: 'Aravind',
        customerEmail: 'aravind@prestine.in',
        activationDate: '2022-10-05T12:00:00.000Z',
        renewalDate: '2022-10-25T12:00:00.000Z',
        expiredDate: '2022-10-25T12:00:00.000Z',
        packageName: 'Trial',
        price: 0,
        status: 'Active',
    },
    {
        id: '0004',
        name: 'Mujeeb',
        customerEmail: 'Mujeeb@prestine.in',
        activationDate: '2022-10-05T12:00:00.000Z',
        renewalDate: '2023-10-05T12:00:00.000Z',
        expiredDate: '2025-10-05T12:00:00.000Z',
        packageName: 'Advanced',
        price: 15000,
        status: 'Active',
    },
    
];
